export enum UserActivityStatus {
  NotConfirmed = 0,
  ConfirmedOnBoard = 1,
  SignedOff = 2,
}
